import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";

const InputLabel = ({ name, label = "", errorMessage, errorLabelId }) => {
    return (
        <label className={ styles.inputLabel } htmlFor={ `form-element-${ name }` }>
            { errorMessage ? <span id={ errorLabelId }>{ errorMessage }</span> : label }
        </label>
    );
};

InputLabel.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    errorMessage: PropTypes.string,
    errorLabelId: PropTypes.string
};

export default InputLabel;
